<script>
export const pageName = 'tools-parachute-calculator';
export const pageRoute = '/tools/parachute-calculator';
export const title = 'Parachute Calculator'

export default {
	data() {
		return { 
			shape: 'hexagon',
			descentRate: 4.5,
			dragCoefficient: 0.75,
			mass: 0.3,
			airDensity: 1.225,
			g: 9.8067,
			spillHolePercentage: 10,

			spillHoleDiameter: 0,
			spillHoleArea: 0,
			parachuteReferenceArea: 0,
			parachuteDiameter: 0
		}
	},

	methods: {
		calculate() {
			let descentFactor = 2 * this.mass * this.g / (this.descentRate * this.descentRate * this.airDensity * this.dragCoefficient);
			let shapeCoefficient = 1;

			switch (this.shape) {
				case "dome":
				case "circle":
					shapeCoefficient = Math.sqrt(4 * descentFactor / Math.PI);
					break;
				case "hexagon":
					shapeCoefficient = Math.sqrt(2 * descentFactor / Math.sqrt(3));
					break;
				case "octagon":
					shapeCoefficient = Math.sqrt(descentFactor / (2 * (Math.SQRT2 - 1)));
					break;
				case "square":
					shapeCoefficient = Math.sqrt(descentFactor)
			}

			this.spillHoleDiameter = shapeCoefficient * this.spillHolePercentage / 100;
			this.spillHoleArea = .25 * Math.PI * this.spillHoleDiameter * this.spillHoleDiameter;
			this.parachuteReferenceArea = descentFactor + this.spillHoleArea;
			this.parachuteDiameter = Math.sqrt(4 * this.parachuteReferenceArea / Math.PI);
			let areaDescreasingPercentageBecauseOfAddingASpillHole = 100 * this.spillHoleArea / descentFactor;			
		},
		show() {
			this.calculate();
		}
	}
}

</script>
<template>
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-12 col-md-6 my-5">
				<h1 class="display-4 text-center mb-3">Parachute Size Calculator</h1>
				<p class="text-muted text-center mb-5">Work how how large a parachute you need.</p>
				<form>
					<fieldset>
						<div class="row">
							<div class="col-6">
								<div class="form-group">
									<label>Parachute shape</label>
									<select @input="calculate" class="form-control" v-model="shape">
										<option value="circle">Circle / Dome</option>
										<option value="square">Square</option>
										<option value="hexagon">Hexagon</option>
										<option value="octagon">Octagon</option>
									</select>
									<span class="invalid-feedback"></span>
								</div>
							</div>
							<div class="col-6">
								<div class="form-group">
									<label>Spill hole relative diameter</label>
									<div class="input-group has-validation">
										<input @input="calculate" type="number" min="0" max="100" step="1" autocomplete="off" v-model="spillHolePercentage" class="form-control" placeholder="e.g. 4.5" />
										<div class="input-group-append">
											<div class="input-group-text">
												%
											</div>
										</div>
										<span class="invalid-feedback"></span>
									</div>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-6">
								<div class="form-group">
									<label>Drag coefficient</label>
									<input @input="calculate" type="number" min="0.1" max="1" step="0.1" autocomplete="off" v-model="dragCoefficient" class="form-control" placeholder="e.g. 0.75" />									
									<span class="invalid-feedback"></span>
								</div>
							</div>
							<div class="col-6">
								<div class="form-group">
									<label>Rocket mass</label>
									<div class="input-group has-validation">
										<input @input="calculate" type="number" min="1" max="9999" step="1" autocomplete="off" v-model="mass" class="form-control" />
										<div class="input-group-append">
											<div class="input-group-text">
												kg
											</div>
										</div>
										<span class="invalid-feedback"></span>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-6">
								<div class="form-group">
									<label>Air density</label>
									<div class="input-group has-validation">
										<input @input="calculate" type="number" min="0.1" max="50" step="0.1" autocomplete="off" v-model="airDensity" class="form-control" />
										<div class="input-group-append">
											<div class="input-group-text">
												kg/m<sup>3</sup>
											</div>
										</div>
										<span class="invalid-feedback"></span>
									</div>
								</div>
							</div>
							<div class="col-6">
								<div class="form-group">
									<label>Descent rate</label>
									<div class="input-group has-validation">
										<input @input="calculate" type="number" min="1" max="100" step="0.1" autocomplete="off" v-model="descentRate" class="form-control" placeholder="e.g. 4.5" />
										<div class="input-group-append">
											<div class="input-group-text">
												m/s
											</div>
										</div>
										<span class="invalid-feedback"></span>
									</div>
								</div>
							</div>
						</div>
						
					</fieldset>
				</form>
				<hr />
				<div class="list-group list-group-flush mb-4">
					<div class="list-group-item">
						<div class="row align-items-center">
							<div class="col">
								Parachute diameter/size across
							</div>
							<div class="col-auto">
								{{ parachuteDiameter.toFixed(2) }}m
							</div>
						</div>
					</div>
					<div class="list-group-item">
						<div class="row align-items-center">
							<div class="col">
								Spill hole diameter
							</div>
							<div class="col-auto">
								{{ spillHoleDiameter.toFixed(2) }}m
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
